import { Eyebrow, MaskHeading, Reveal, Gold } from "./Motion";
import { VALUES } from "./data";

const ValueCard = ({ v, i }) => (
  <Reveal delay={i * 0.12} className="h-full">
    <article data-testid={v.testId} className="group relative flex h-full flex-col overflow-hidden rounded-[28px] border border-ns-emerald/10 bg-white p-8 transition-[transform,box-shadow] duration-500 hover:-translate-y-2 hover:shadow-[0_30px_60px_-30px_rgba(11,60,42,0.35)]">
      <div className="flex items-center justify-between">
        <span className="grid h-12 w-12 place-items-center rounded-full bg-ns-emerald font-sans text-sm font-extrabold tracking-[0.08em] text-ns-gold transition-colors duration-500 group-hover:bg-ns-gold group-hover:text-ns-emerald">{v.n}</span>
        <span className="h-px flex-1 ml-4 bg-ns-emerald/10" />
      </div>
      <h3 className="mt-8 font-serif text-3xl font-semibold leading-tight text-ns-emerald">{v.title}</h3>
      <p className="mt-3 text-[15px] leading-relaxed text-ns-muted">{v.text}</p>
      <ul className="mt-6 flex flex-wrap gap-2">
        {v.points.map((pt) => (
          <li key={pt} className="rounded-full bg-ns-cream px-3 py-1 text-xs font-semibold text-ns-emerald">{pt}</li>
        ))}
      </ul>
      <span className="absolute bottom-0 left-0 h-[3px] w-0 bg-ns-gold transition-[width] duration-700 ease-out group-hover:w-full" />
    </article>
  </Reveal>
);

const FarmerBand = () => (
  <Reveal className="mt-20">
    <figure data-testid="story-farmer-band" className="relative overflow-hidden rounded-[32px] bg-ns-night">
      <img src="/images/farmer.jpg" alt="Makhana farmer in a lotus field in Bihar" loading="lazy" className="h-[460px] w-full object-cover object-[70%_center] sm:h-[520px]" />
      <div className="absolute inset-0 bg-gradient-to-t from-ns-night/90 via-ns-night/40 to-transparent md:bg-gradient-to-r md:from-ns-night/85 md:via-ns-night/30" />
      <figcaption className="absolute inset-x-0 bottom-0 p-7 sm:p-12 md:max-w-[58%]">
        <p className="text-[11px] font-bold uppercase tracking-[0.28em] text-ns-gold">Our promise</p>
        <blockquote className="mt-4 font-serif text-3xl font-medium leading-tight text-ns-ivory sm:text-[2.6rem]">
          “No product bearing the NutriSwaad label will ever compromise your health.”
        </blockquote>
        <p className="mt-5 text-sm text-ns-ivory/85">Thank you for empowering the farmers of Bihar with NutriSwaad!</p>
      </figcaption>
    </figure>
  </Reveal>
);

export const Story = () => (
  <section id="story" data-testid="story-section" className="relative bg-ns-ivory py-24 md:py-36">
    <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
      <div className="grid gap-12 lg:grid-cols-12 lg:gap-16">
        <div className="lg:col-span-6">
          <Eyebrow testId="story-eyebrow">01 / Our Story</Eyebrow>
          <MaskHeading
            testId="story-heading"
            className="mt-6 font-serif text-[2.6rem] font-semibold leading-[1.02] tracking-[-0.01em] text-ns-emerald sm:text-6xl lg:text-7xl"
            lines={["Good food is", "not a trend.", <Gold key="g">It is a promise.</Gold>]}
          />
        </div>
        <div className="flex flex-col justify-end gap-6 lg:col-span-5 lg:col-start-8">
          <Reveal>
            <p data-testid="story-paragraph-origin" className="font-serif text-2xl leading-snug text-ns-ink sm:text-[1.7rem]">
              Born in the soil of Bihar, NutriSwaad is an independent FMCG company on a mission to replace harmful, oil-fried junk with food that families can trust.
            </p>
          </Reveal>
          <Reveal delay={0.1}>
            <p data-testid="story-paragraph-mission" className="text-base leading-relaxed text-ns-muted">
              Rooted in a deep respect for the fertile soil of Bihar and its agricultural heritage, we transform traditional superfoods like Makhana into modern, hygienic, world-class snacking. Advanced zero-oil roasting and air-tight, induction-sealed packaging keep every bite crunchy, pure and wholesome. Our mission is simple yet impactful: to make healthy snacking accessible, scalable and profitable while uplifting the farmers who grow it.
            </p>
          </Reveal>
        </div>
      </div>
      <FarmerBand />
      <div className="mt-5 grid gap-5 md:grid-cols-3">
        {VALUES.map((v, i) => <ValueCard key={v.testId} v={v} i={i} />)}
      </div>
    </div>
  </section>
);
